import { logger } from "../utils/utils";
import api from "./apis/api";

class NutrientsService {
  createNutrient(payload) {
    logger("NutrientsService", "createNutrient");
    return api.nutrients.createNutrient(payload);
  }

  updateNutrient(payload) {
    logger("NutrientsService", "updateNutrient");
    return api.nutrients.updateNutrient(
      payload?.nutrientID,
      payload?.payload,
    );
  }

  getNutrientsList(payload) {
    logger("NutrientsService", "getNutrientsList");
    return api.nutrients.getNutrientsList(payload || {});
  }
  
  deleteNutrient(nutrientID){
    logger("NutrientsService", "deleteNutrient");
    return api.nutrients.deleteNutrient(nutrientID);
  }
}

const nutrientsService = new NutrientsService();
export default nutrientsService;
